import { render } from "./BLItem.vue?vue&type=template&id=5e318c9d"
import script from "./BLItem.vue?vue&type=script&lang=js"
export * from "./BLItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__